// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"121":"f801717d","388":"d9abfc63","394":"326e3ff0","426":"a6b33ccb","798":"d9abfc63","981":"51597f2f"}[chunkId] + ".chunk.css";
};